<template>
	<div class="app-main">
		<div style="padding-bottom: 5px;display: flex;align-items: center;">
			<el-divider direction="vertical"></el-divider>
			<span>公司附件</span>
		</div>
		<el-row class="mg-b5">
			<el-table :data="tableData" border size="mini" :header-cell-style="headerCellStyle">
				<el-table-column label="附件类型" prop="fjType" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<span>{{scope.row.fjType?scope.row.fjType.join(' / '):''}}</span>
					</template>
				</el-table-column>
				<el-table-column label="附件描述" prop="fjDescribe" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="endDate" label="文件到期日" :show-overflow-tooltip="true" width="120">
				</el-table-column>
				<el-table-column prop="lastUpdateTime" label="最后更新时间" :show-overflow-tooltip="true" width="120">
				</el-table-column>
				<el-table-column label="附件" width="95">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.src==undefined" type="info">无附件
						</el-tag>
						<el-link v-else :underline="false" :href="baseURL+scope.row.src" target="_blank">
							<el-tag type="success">查看附件</el-tag>
						</el-link>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="100" align="center" fixed="right">
					<template slot="header" slot-scope="scope">
						<el-button size="small" plain type="primary" @click="handleAdd" >新增
						</el-button>
					</template>
					<template slot-scope="scope">
						<el-button type="text" size="small" @click="handleEdit(scope.row)" >修改
						</el-button>
						<el-button type="text" size="small" @click="handleDel(scope.row.rowId)" >删除
						</el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-row>
		<div v-if="!preview" style="text-align: center;">
			<span slot="footer" class="dialog-footer">
				<el-button @click="backStep" size="small">上一步</el-button>
				<el-button type="primary" @click="nextStep" size="small">下一步</el-button>
			</span>
		</div>
		<el-dialog :visible.sync="openDialog" width="600px" :title="title" :close-on-click-modal="false">
			<el-form label-width="100px" ref="form" :model="form" :rules="rules" size="small">
				<el-row>
					<el-col :span="24">
						<el-form-item label="附件类型" prop="fjType">
							<el-cascader v-model="form.fjType" style="width: 100%;" :options="options"
								@change="handleChange"></el-cascader>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="附件描述" prop="fjDescribe">
							<el-input v-model="form.fjDescribe" placeholder="请输入附件描述" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="文件到期日" prop="endDate">
							<el-date-picker type="date" placeholder="选择日期" v-model="form.endDate"></el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="附件" prop="src">
							<el-upload class="upload-demo" :action="upload()" :show-file-list="false"
								accept="image/*,.pdf,.doc,.docx,.xlsx" :on-success="handleAvatarSuccess"
								:before-upload="beforeAvatarUpload" :headers="{'Authentication':token()}">
								<el-input v-model="form.src" placeholder="点击文本框上传" readonly slot="trigger" />
							</el-upload>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="openDialog = false" size="small">取 消</el-button>
				<el-button type="primary" @click="submitForm" size="small">确 定</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
	import {
		supplierAttachList,
		addSupplierAttach,
		editSupplierAttach,
		delSupplierAttach,
	} from '@/api/gys/supplierAttach.js'
	import{addSupplierApprovalMx, getSupplierApprovalMx} from '@/api/gys/supplierInfo.js'
	import { createHash } from '@/utils/index'
	export default {
		name: "FileInfo",
		computed: {},
		props: {
			basicId: {
				type: Number,
			},
			preview: {
				type: Boolean,
				default: false
			},
			otherInfo: {
				type: Object,
				default: {}
			}
		},
		data() {
			return {
				title: "",
				tableData: [],
				form: {},
				loadingInstance: undefined,
				openDialog: false,
				count: 0,
				fileName: '',
				options: [{
					value: '质量认证',
					label: '质量认证',
					children: [{
						value: 'ISO9001质量认证',
						label: 'ISO9001质量认证',
					}, {
						value: 'ISO9000质量认证',
						label: 'ISO9000质量认证',
					}]
				}, {
					value: '基本资质',
					label: '基本资质',
					children: [{
						value: 'ISO9001营业执照',
						label: 'ISO9001营业执照',
					}, {
						value: 'ISO9000组织机构代码证',
						label: 'ISO9000组织机构代码证',
					}, {
						value: '代理证',
						label: '代理证',
					}]
				}, {
					value: '环境认证',
					label: '环境认证',
					children: [{
						value: 'ISO14001环境管理体系营业执照',
						label: 'ISO14001环境管理体系营业执照',
					}]
				}, {
					value: '其他',
					label: '其他',
				}],
				quertInfo: {
					page: 1, //当前页码
					limit: 20, //当前每页显示的数量
					searchTime: [],
					objMap: {
						search: '',
						hId: this.basicId,
					}
				},
				rules: {
					fjType: [{
						required: true,
						message: '请选择',
						trigger: 'blur'
					}],
					fjDescribe: [{
						required: true,
						message: '请输入附件描述',
						trigger: 'blur'
					}],
					endDate: [{
						required: true,
						message: '请输入文件到期日',
						trigger: 'blur'
					}],
					lastUpdateTime: [{
						required: true,
						message: '请输入最后更新时间',
						trigger: 'blur'
					}],
					src: [{
						required: false,
						message: '请输入附件',
						trigger: 'blur'
					}],
					status: [{
						required: true,
						message: '请输入状态',
						trigger: 'blur'
					}],
				}
			};
		},
		created() {
			this.getList();
		},
		methods: {
			onPagination: function(val) {
				this.quertInfo.page = val.page;
				this.quertInfo.limit = val.limit;
				this.getList();
			},
			async getList() {
				let _this = this;
				let pramar = {
					classType:'com.srm.entity.SupplierAttach',
					classTypeIndex:'0',
					supplierInfoId:_this.basicId,
				};
				if(this.otherInfo.lastPass){
					pramar['queryType']='lastPass'
				}
				getSupplierApprovalMx(pramar).then(({data:res}) => {
					console.log(res)
					this.tableData = [];
					if(res.data && res.data.jsonData){
						this.tableData = JSON.parse(res.data.jsonData)
					}
				})
			},
			onSearch: function() {
				//重置页码（会出现查询搜索字段在当前页码之前，会查询不到）
				this.quertInfo.page = 1;
				this.getList();
			},
			// 表单重置
			reset: function() {
				this.form = {
					id: undefined,
					createTime: undefined,
					createUser: this.$store.getters['user/user'].id,
					fjType: undefined,
					fjDescribe: undefined,
					endDate: undefined,
					lastUpdateTime: undefined,
					src: undefined,
					status: 0,
					hId: this.basicId,
				}
				if (this.$refs["form"] !== undefined) {
					this.$refs["form"].resetFields();
				}
			},
			submitForm() {
				let _this = this;
				_this.$refs['form'].validate((valid) => {
					if (valid) {
						let oldData = JSON.parse(JSON.stringify(_this.tableData))
						let data = JSON.parse(JSON.stringify(_this.form));
						if (data.rowId != undefined) {
							let num = -1;
							oldData.forEach((nItem,index)=>{
								if(nItem.rowId == data.rowId){
									num = index;
								}
							})
							if(num>=0){
								oldData[num] = data;
							}
							_this.addFun(oldData);
						} else {
							data.rowId = createHash();
							oldData.push(data)
							_this.addFun(oldData);
						}
					}
				});
			},
			addFun(data){
				let _this = this;
				addSupplierApprovalMx({
					classType:'com.srm.entity.SupplierAttach',
					classTypeIndex:'0',
					supplierInfoId:this.basicId,
					jsonData:JSON.stringify(data)
				}).then((res)=>{
					_this.$success('添加成功');
					_this.openDialog = false;
					_this.getList();
				})
			},
			handleAdd: function() {
				this.reset();
				this.title = "新增";
				this.openDialog = true;
			},
			handleEdit: function(row) {
				this.reset();
				this.title = "修改";
				this.form = JSON.parse(JSON.stringify(row)); //直接赋值 表格数据 也会改变 要深拷贝复制
				console.log(this.form)
				// this.form.fjType = this.form.fjType.split(",")
				this.openDialog = true;
			},
			//上一步
			backStep: function() {
				this.bus.$emit('stepsFun', 7);
			},
			//下一步
			nextStep: function() {
				this.bus.$emit('stepsFun', 9);
			},

			handleDel: function(id) {
				let _this = this;
				let oldData = JSON.parse(JSON.stringify(_this.tableData))
				let newData = [];
				oldData.forEach((item)=>{
					if(item.rowId != id){
						newData.push(item)
					}
				})
				_this.confirm({
					text: '确认删除吗',
					tip: '警告',
					type: '',
					fn: function(param) {
						_this.addFun(param);
					},
					data: newData //参数对象 主要回调函数用
				});
			},
			handleChange: function(val) {
				console.log(val)
			},
			handleAvatarSuccess(res, file) {
				if (res.code == 0) {
					this.$success(res.msg);
					if (this.form.src != "" && this.form.src != undefined) {
						//如果修改附件 则删除原来的附件
						if (this.form.src != res.data.url) {
							this.delFile(this.form.src);
						}
					}
					this.form.src = res.data.url;
				}
			},
			beforeAvatarUpload(file) {
				//      let type = file.name.substring(file.name.lastIndexOf('.') + 1) //判断文件后缀
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$fail('上传附件大小不能超过 2MB!');
				}
				return isLt2M;
			},

		}
	};
</script>
<style scoped="scoped">
</style>
